import { ChangeDetectionStrategy, Component, Input, OnInit } from '@angular/core';
import { SanitizeContentfulHTMLPipe } from '../../../../../shared/pipes/sanitize-contentful-html.pipe';

@Component({
  selector: 'app-contentful-category-title',
  standalone: true,
  styleUrl: './contentful-category-title.styles.scss',
  imports: [SanitizeContentfulHTMLPipe],
  templateUrl: './contentful-category-title.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AppContentfulCategoryTitleComponent implements OnInit {
  @Input() contentfulCategory: any;
  categoryTitle: string | undefined;

  ngOnInit(): void {
    if (this.contentfulCategory?.title) {
      this.categoryTitle = this.contentfulCategory.title;
    } else if (
      !this.contentfulCategory?.title &&
      this.contentfulCategory?.categoryHeading &&
      this.contentfulCategory?.categoryHeading !== ''
    ) {
      this.categoryTitle = this.contentfulCategory.categoryHeading;
    }
  }
}
